import { createFileRoute } from "@tanstack/react-router";
import { CliAuthCompletePage } from "@/components/cli-auth/cli-auth-complete-page";

export const Route = createFileRoute("/_app/cli-auth/$sessionId/complete/")({
  component: CliAuthCompletePage,
  head: () => ({
    meta: [{ title: "CLI Auth Complete - Papier" }],
  }),
});
